export default __webpack_public_path__ + "static/media/team91.ee352480.JPG";